import { useTranslation } from 'react-i18next'
import { ChangeEventHandler } from 'react'
import { FormControl, NativeSelect } from '@mui/material'

import { useStyles } from './styles'

interface IRowsSelectProps {
  handleChange: ChangeEventHandler<HTMLSelectElement>
  rowsPerPage: number
  withAll?: boolean
  disabled?: boolean
}

interface IPaginationOption {
  value: number | undefined
  label: string | number
}

const RowsSelect = ({ handleChange, rowsPerPage, withAll, disabled }: IRowsSelectProps) => {
  const [t] = useTranslation()
  const classes = useStyles({})

  const paginationOptions: Array<IPaginationOption> = [
    { value: 10, label: 10 },
    { value: 25, label: 25 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ]
  withAll && paginationOptions.push({ value: NaN, label: t('all-text.v') })

  return (
    <FormControl>
      <NativeSelect
        onChange={handleChange}
        value={rowsPerPage}
        disabled={disabled}
        inputProps={{
          name: 'rowsNumber',
          id: 'rowsNumber',
          style: {
            padding: 0,
          },
        }}
        className={classes.paginationSelectWrapper}
      >
        {paginationOptions.map(({ value, label }) => (
          <option key={value} className={classes.paginationSelectOption} value={value}>
            {label}
          </option>
        ))}
      </NativeSelect>
    </FormControl>
  )
}

export { RowsSelect }
